import React, { Component } from "react";
import {
  withStyles, Box, TextField, InputAdornment, IconButton, LinearProgress,
  Menu, MenuItem, Dialog, DialogContent, DialogTitle, Grid,
} from "@material-ui/core";
import Button from "../../components/JMuiButton";
import { Close as CloseIcon, MoreHoriz as MoreHorizIcon } from "@material-ui/icons";
import { inject, observer } from "mobx-react";
import _ from "lodash";
import { styles } from "./styles";
import List from "../../components/List";
import { userActions, userDetail } from "../../constants/settings";
import { ModalDialog } from "../../components/Modal";
import CSRFComponent from "../../components/CSRFComponent";
import Password from "../../components/Password";
import { toast } from "react-toastify";
  
@inject("usersManager", "userStore")
@observer
class UsersList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      keyword: '',
      menu: {},
      openRemoveModal: false,
      openResetModal: false,
      selectedUser: {},
      error: '',
      submitting: false,
      generatePasswordType: 'auto',
      password: '',
      password2: '',
      showPassword: false,
      sendEmail: false,
      formErrors: [],
      passwordError: '',
      password2Error: '',
      auth_password: '', // The password of user logged into the system
    }
  }

  componentDidMount() {
    this.props.usersManager.search();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { password, password2 } = this.state;
    const { password: prevPass, password2: prevPass2 } = prevState;
    const formErrors = [];
    let passwordError = '';
    let password2Error = '';

    if (prevPass !== password || prevPass2 !== password2) {
      if (!password.match(/(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{6,})/g) || password.match(/\s/g)) {
        const msg = "Password must has at least one lowercase letter, one uppercase letter, one digit, one special character, no spaces and is at least 6 characters long";
        formErrors.push(msg);
        passwordError = msg;
      }
      if (password2 !== password) {
        const msg = "Confirm password does not match";
        formErrors.push(msg);
        password2Error = msg;
      }
      this.setState({ formErrors, passwordError, password2Error });
    }
  }

  handleSearch = (e) => {
    const { keyword } = this.state;
    const { usersManager } = this.props;

    if (e.which === 13) {
      usersManager.setFilter("q", keyword);
      usersManager.setFilter("page", 1);
      usersManager.search();
    }
  }

  clearSearch = () => {
    const { usersManager } = this.props;

    this.setState({ keyword: '' });
    usersManager.setFilter("q", '');
    usersManager.search();
  }

  closeRemoveModal = () => {
    this.setState({
      openRemoveModal: false,
      selectedUser: {},
      error: '',
    })
  }

  closeResetModal = () => {
    this.setState({
      openResetModal: false,
      selectedUser: {},
      generatePasswordType: 'auto',
      error: '',
      password: '',
      password2: '',
      showPassword: false,
      sendEmail: false,
      formErrors: [],
      auth_password: '',
    })
  }

  onInputChange = (field, value) => {
    this.setState({ [field]: value, error: '' });
  }

  removeUser = () => {
    const { selectedUser } = this.state;
    const { usersManager } = this.props;

    this.setState({ submitting: true, error: '' });
    usersManager.removeUser(selectedUser.id, true, res => {
      this.setState({ submitting: false });
      if (res.ok) {
        usersManager.search();
        this.closeRemoveModal();
      } else {
        this.setState({ error: res.data ? res.data.message : 'Error!' })
      }
    })
  }

  resetPassword = () => {
    const { password, selectedUser, generatePasswordType, sendEmail, auth_password } = this.state;
    const { usersManager } = this.props;

    if (!auth_password) {
      this.setState({ error: 'Your password is required!' });
      return;
    }

    if (generatePasswordType === 'manual' && !password) {
      this.setState({ error: 'Password is required!' });
      return;
    }

    this.setState({ submitting: true });
    usersManager.resetPassword(selectedUser.id, generatePasswordType, password, sendEmail, auth_password, (res) => {
      this.setState({ submitting: false });
      if (res.ok) {
        toast.success('Password reset successfully!');
        this.closeResetModal();
      } else if (res?.data?.error_type == 'CSRF_ERROR') {
        toast.error(res?.data?.message || 'CSRF token expired. Try to submit again!');
      } else {
        this.setState({ error: res?.data?.message || 'Your password mismatch!' })
      }
    })
  }

  openActions = (userId, e) => {
    this.setState({ menu: { ...this.state.menu, [userId]: e.currentTarget } })
  }

  closeActions = (userId) => {
    this.setState({ menu: { ...this.state.menu, [userId]: null } })
  }

  doAction = (action, user) => () => {
    if (action === 'edit') {
      this.props.openEditUser(user);
    } else if (action === 'reset') {
      this.setState({
        openResetModal: true,
        selectedUser: user,
      })
    } else if (action === 'remove') {
      this.setState({
        openRemoveModal: true,
        selectedUser: user,
      })
    }
    this.closeActions(user.id);
  }

  renderRole = (user, field) => {
    const roles = _.get(user, field);
    const roleList = !!roles ? roles.trim().split(" ").filter(r => !!r).map(r => r.trim()) : [];
    if (roleList.includes("client-admin")) {
      return "Admin";
    } else if (roleList.includes("client")) {
      return "Team Member";
    } else if (roleList.includes("client-read-only")) {
      return "View Only";
    } else {
      return "Other";
    }
  }

  handleResetPasswordType = (type) => {
    this.setState({
      generatePasswordType: type,
      error: '',
      password: '',
      password2: '',
      auth_password: '',
      formErrors: [],
      passwordError: '',
      passwordError2: ''
    })
  }

  renderActions = (user) => {
    const { menu } = this.state;
    const { client } = this.props.userStore;

    return (
      <Box align="center">
        <IconButton onClick={e => this.openActions(user.id, e)} size="small">
          <MoreHorizIcon color="inherit" />
        </IconButton>
        <Menu
          anchorEl={menu[user.id]}
          keepMounted
          open={Boolean(menu[user.id])}
          onClose={() => this.closeActions(user.id)}
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: "center", horizontal: "center" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
        >
          {userActions.map(action => {
            if (client.user_id === user.id && action.value === 'remove') {
              return null;
            } else {
              return (
                <MenuItem onClick={this.doAction(action.value, user)} key={action.value}>
                  {action.label}
                </MenuItem>
              )
            }
          })}
        </Menu>
      </Box>
    )
  }

  render() {
    const {
      keyword, openRemoveModal, openResetModal, selectedUser, submitting, error,
      generatePasswordType, showPassword, sendEmail, formErrors
    } = this.state;
    const { usersManager, classes } = this.props;
    const renderer = {
      _scopes: (user, field) => this.renderRole(user, field),
      actions: (user) => this.renderActions(user),
    }

    let disableResetPassword = submitting
      || !this.state.auth_password
      || (generatePasswordType === 'manual' && formErrors.length);

    return (
      <Box>
        <Box mb={2}>
          <TextField
            value={keyword}
            onChange={e => this.setState({ keyword: e.target.value })}
            onKeyPress={e => this.handleSearch(e)}
            fullWidth
            variant="outlined"
            color="primary"
            placeholder="Search users by username or ID ..."
            margin="dense"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={this.clearSearch} edge="end" size="small">
                    <CloseIcon />
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
        </Box>
        <Box>
          <List store={usersManager} renderer={renderer} emptyResponse="No users found" />
        </Box>

        <Dialog open={openRemoveModal}
          onClose={this.closeRemoveModal}
        >
          <DialogTitle disableTypography className={classes.titleWrapper}>
            <IconButton className={classes.closeIcon} onClick={this.closeRemoveModal}>
              <CloseIcon color="inherit" fontSize="large" />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Box p={3} align="center">
              <Box py={2} className={classes.removeTitle}>Are you sure to remove user <em>{selectedUser.username}</em> ?</Box>
              <Box mb={1}>
                <Button onClick={this.closeRemoveModal} className={classes.button} variant="contained" color="secondary" disableElevation>
                  Cancel
                </Button>
                <Button onClick={this.removeUser} loading={submitting} disabled={submitting} className={classes.button + ' ' + classes.redButton} variant="contained" color="primary" disableElevation>
                  Remove
                </Button>
              </Box>
              {submitting && <LinearProgress color="primary" />}
              {error && <Box p={1} className={classes.error}>{error}</Box>}
            </Box>
          </DialogContent>
        </Dialog>

        <ModalDialog
          open={openResetModal}
          title="Reset User Password"
          onClose={this.closeResetModal}
          onOk={this.resetPassword}
          okLabel="Reset"
          loading={submitting}
          disabledOk={disableResetPassword}
        >
          <CSRFComponent
            onError={(error) => toast.error("Failed to fetch CSRF token. Please try again")}
          />
          <Box style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '24px' }}>
            {userDetail.map(field => (
              <Grid key={field.name} sm={field.size} style={{ display: 'flex' }}>
                <Grid item xs={3}>
                  <div className={classes.tableHeader} style={{ fontSize: '13px' }} py={1}>{field.label} </div>
                </Grid>
                <Grid item xs={9}>
                  <div className={classes.tableCell} py={1}>
                    {renderer[field.name] ? renderer[field.name](selectedUser, field.name) : _.get(selectedUser, field.name)}
                  </div>
                </Grid>
              </Grid>
            ))}
          </Box>

          <Box>
            <Password
              value={this.state.auth_password}
              onChange={(e) => this.onInputChange('auth_password', e.target.value)}
              disabled={submitting}
              label="Your Password"
              placeholder=""
              required={true}
              showLabel={true}
            />
            <Box className={classes.errorBox}>
              {error && <Box p={1} className={classes.error}>{error}</Box>}
            </Box>
          </Box>
          <Box py={1} className={classes.hint}>*Reset password url will be sent to user’s registered email. The token will be valid for short duration.</Box>
        </ModalDialog>
      </Box>
    );
  }
}

export default withStyles(styles)(UsersList);